var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 2.89543 5.89543 2 7 2H16C17.1046 2 18 2.89543 18 4V13C18 14.1046 17.1046 15 16 15H7C5.89543 15 5 14.1046 5 13V4ZM10.9189 8.86844V5.14865C10.9189 4.79041 11.2093 4.5 11.5676 4.5H13.8378C14.1961 4.5 14.4865 4.79041 14.4865 5.14865V6.44595C14.4865 6.80419 14.1961 7.0946 13.8378 7.0946H12.2162C12.0371 7.0946 11.8919 7.2398 11.8919 7.41892V10.5541C11.8919 11.6288 11.0207 12.5 9.94595 12.5C8.87123 12.5 8 11.6288 8 10.5541C8 9.47934 8.87123 8.60811 9.94595 8.60811C10.3004 8.60811 10.6327 8.70287 10.9189 8.86844Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.99997C4 6.44768 3.55228 5.99997 3 5.99997C2.44772 5.99997 2 6.44768 2 6.99997V14C2 16.2091 3.79086 18 6 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H6C4.89543 16 4 15.1045 4 14V6.99997Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicLibrary);
export default __webpack_public_path__ + "static/media/music-library.2ae72a8fbb346ffbd3206c7730f2fdf2.svg";
export { ForwardRef as ReactComponent };